import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import Icon from 'antd/lib/icon';
import Table from 'antd/lib/table';
import draftToHtml from 'draftjs-to-html';
import { Checkbox } from 'antd';
import { ResponsiveTable } from '../../../../common/components/data-display';
import { formatDateTime } from '../../../../common/utils/helpers';

const Column = Table.Column;

const MessageList = ({ messages, messagesFilter, t, isLoading, onFilterChange }) => {
  const options = [
    { label: t('Interná komunikácia'), value: 'internal' },
    { label: t('Externá komunikácia'), value: 'external' },
  ];

  return (
    <section className="documents-wrapper message-table">
      <div style={{ textAlign: 'center', marginBottom: '10px' }}>
        <Checkbox.Group options={options} onChange={onFilterChange} value={messagesFilter} />
      </div>
      <ResponsiveTable dataSource={messages} rowKey={mes => mes.id} loading={isLoading}>
        <Column
          width="75%"
          key="message"
          title={t('Správa')}
          render={mes => (
            <div className="message-table-text" dangerouslySetInnerHTML={{ __html: draftToHtml(mes.message) }} />
          )}
        />
        <Column
          key="author_date"
          title={t('Zadávateľ / Dátum pridania')}
          render={mes => (
            <div className="message-table-info">
              <span>{mes.creatorAccountName}</span>
              <br/>
              <span>{formatDateTime(mes.createdAt)}</span>
            </div>
          )}
        />
      </ResponsiveTable>
    </section>
  );
};

MessageList.propTypes = {
  messages: PropTypes.array.isRequired,
  messagesFilter: PropTypes.array.isRequired,
  t: PropTypes.func.isRequired,
};

export default translate()(MessageList);



// WEBPACK FOOTER //
// ./src/features/account-management/components/messages/MessageList.js